/* Zona Verde – interacciones del tema (sin dependencias). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aparición al hacer scroll (escalonada dentro de cada grupo) */
  var revealSelector = [
    '.heading', '.heading-row', '.cat-card', '.card', '.feature', '.beneficio', '.split__media', '.split__copy',
    '.frase .container > *', '.promo', '.pedido > *', '.newsletter .container > *',
    '.cta', '.faq__item', '.form-card', '.contact-list li', '.product__info > *',
    '.page-banner .container > *', '.footer__grid > *', '.rte--lead'
  ].join(',');
  var revealItems = document.querySelectorAll(revealSelector);
  if (!reduceMotion && 'IntersectionObserver' in window && revealItems.length) {
    document.documentElement.classList.add('js-reveal');
    var counters = new Map();
    revealItems.forEach(function (el) {
      var parent = el.parentElement;
      var i = counters.get(parent) || 0;
      counters.set(parent, i + 1);
      el.style.setProperty('--reveal-delay', Math.min(i, 6) * 110 + 'ms');
      el.setAttribute('data-reveal', '');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealItems.forEach(function (el) { io.observe(el); });
  }

  /* Cabecera compacta al hacer scroll */
  var headerSection = document.querySelector('.section-header');
  if (headerSection) {
    var onScroll = function () {
      headerSection.classList.toggle('is-scrolled', window.scrollY > 60);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Barra de anuncios rotativa */
  var ann = document.querySelector('[data-announcement]');
  if (ann) {
    var slides = ann.querySelectorAll('.announcement__slide');
    var cur = 0;
    var show = function (n) {
      slides[cur].classList.remove('is-active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('is-active');
    };
    if (slides.length > 1) {
      var timer = setInterval(function () { show(cur + 1); }, 4500);
      var reset = function () { clearInterval(timer); timer = setInterval(function () { show(cur + 1); }, 4500); };
      ann.querySelector('[data-ann-next]').addEventListener('click', function () { show(cur + 1); reset(); });
      ann.querySelector('[data-ann-prev]').addEventListener('click', function () { show(cur - 1); reset(); });
    }
  }

  /* Carrusel de productos */
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var section = slider.closest('section');
    var step = function (dir) {
      var item = slider.firstElementChild;
      var w = item ? item.getBoundingClientRect().width + 20 : 300;
      slider.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    var prev = section && section.querySelector('[data-slider-prev]');
    var next = section && section.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  /* Agregar al carrito sin salir de la página */
  var toast = document.querySelector('[data-toast]');
  var toastTimer;
  var showToast = function (text) {
    if (!toast) return;
    toast.querySelector('[data-toast-text]').textContent = text;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 400);
    }, 3200);
  };
  var updateCount = function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.classList.toggle('is-empty', c.item_count === 0);
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      });
    });
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-ajax-cart], #ProductForm')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || 'No se pudo agregar');
        showToast('¡' + (res.d.product_title || 'Producto') + ' agregado!');
        updateCount();
      })
      .catch(function (err) { showToast(err.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = label; } });
  });

  /* Menú móvil */
  var header = document.querySelector('[data-header]');
  if (header) {
    var openBtn = header.querySelector('[data-menu-open]');
    var setOpen = function (open) {
      header.classList.toggle('is-menu-open', open);
      document.documentElement.classList.toggle('no-scroll', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    };
    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    header.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* Fechas mínimas (pedidos con anticipación) */
  document.querySelectorAll('input[type="date"][data-min-days]').forEach(function (input) {
    var d = new Date();
    d.setDate(d.getDate() + parseInt(input.dataset.minDays || '0', 10));
    var iso = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    input.min = iso;
    if (input.value && input.value < iso) input.value = '';
  });

  /* Ordenar colección */
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* Cantidad +/- */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
      input.value = next;
    });
  });

  /* Login: alternar recuperar contraseña */
  document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var rec = document.getElementById('RecoverForm');
      var log = document.getElementById('LoginForm');
      rec.hidden = !rec.hidden;
      log.hidden = !rec.hidden;
    });
  });
  if (window.location.hash === '#recover') {
    var rf = document.getElementById('RecoverForm');
    if (rf) { rf.hidden = false; document.getElementById('LoginForm').hidden = true; }
  }

  /* Producto: variantes y galería */
  var jsonEl = document.querySelector('[data-product-json]');
  var form = document.getElementById('ProductForm');
  if (jsonEl && form) {
    var product = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var priceEl = document.querySelector('[data-price] .price__now');
    var beforeEl = document.querySelector('[data-price] .price__before');
    var money = function (cents) {
      var fmt = new Intl.NumberFormat('es-PE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PEN' });
      return fmt.format(cents / 100);
    };

    var showMedia = function (id) {
      if (!id) return;
      document.querySelectorAll('.product__slide').forEach(function (s) {
        s.classList.toggle('is-active', String(s.dataset.mediaId) === String(id));
      });
      document.querySelectorAll('.product__thumb').forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.thumb) === String(id));
      });
    };

    form.querySelectorAll('[data-option]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var selected = [];
        form.querySelectorAll('[data-option]:checked').forEach(function (r) {
          selected[parseInt(r.dataset.option, 10) - 1] = r.value;
        });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!variant) {
          addBtn.disabled = true;
          addBtn.textContent = 'No disponible';
          return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
        if (priceEl) priceEl.textContent = money(variant.price);
        if (beforeEl) beforeEl.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        if (variant.featured_media) showMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });

    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });
  }

  /* Productos relacionados */
  var rec = document.querySelector('[data-recommendations]');
  if (rec && rec.dataset.url && !rec.children.length) {
    fetch(rec.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) rec.innerHTML = fresh.innerHTML;
        else rec.remove();
      })
      .catch(function () { rec.remove(); });
  }
})();
